import { render, staticRenderFns } from "./AddFAQ.vue?vue&type=template&id=6720bc7a&scoped=true&"
import script from "./AddFAQ.vue?vue&type=script&lang=js&"
export * from "./AddFAQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6720bc7a",
  null
  
)

export default component.exports